import React, { useState, useEffect } from "react";
import { TextField, MenuItem, Grid, InputLabel } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import moment from "moment";

import ModalDialog from "../../CountryData/Components/ModalDialog";
import DateField from "../../../../../Component/Forms/DateField";
import SearchableSelect from "../../../../../Component/Forms/SearchableSelect";

const timeRangeOptions = [
  { label: "last1months", value: 1 },
  { label: "last3months", value: 3 },
  { label: "last6months", value: 6 },
  { label: "customDateRange", value: -1 },
];

const FilterForm = (props) => {
  const { open, classes, filters, countryList = [], onClose, onSubmit } = props;

  const [isDialogOpen, setIsDialogOpen] = useState(open);
  const [timeRange, setTimeRange] = useState(null);
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [country, setCountry] = useState(null);

  const { t } = useTranslation();

  useEffect(() => {
    setIsDialogOpen(open);
  }, [open]);

  useEffect(() => {
    setTimeRange(filters.timeRange);
    setFromDate(filters.fromDate);
    setToDate(filters.toDate);
    setCountry(filters.country);
  }, [filters]);

  useEffect(() => {
    if (timeRange === -1) {
      setFromDate(filters.fromDate);
      setToDate(filters.toDate);
    } else {
      const current = moment();
      const previous = moment().subtract(timeRange, "months");
      setFromDate(previous);
      setToDate(current);
    }
  }, [timeRange]);

  const onTimeRangeChange = (e) => {
    setTimeRange(e.target.value);
  };

  const onFromDateChange = (v) => {
    setFromDate(v);
  };

  const onToDateChange = (v) => {
    setToDate(v);
  };

  const onCountryChange = (c) => {
    setCountry(c);
  };

  const handleClose = () => {
    setIsDialogOpen(false);
    if (onClose) {
      onClose();
    }
  };

  const handleSubmit = () => {
    setIsDialogOpen(false);
    if (onSubmit) {
      onSubmit({ timeRange, fromDate, toDate, country });
    }
  };

  return (
    <ModalDialog
      open={isDialogOpen}
      onClose={handleClose}
      onSubmit={handleSubmit}
      title={t("labels.dashboard.filters.title")}
    >
      <Grid container spacing={2}>
        <Grid item container xs={12} spacing={2}>
          <Grid item xs={4}>
            <InputLabel className={classes.inputLabel}>
              {t("labels.dashboard.filters.title")}
            </InputLabel>
            <TextField
              value={timeRange}
              onChange={onTimeRangeChange}
              select
              variant="outlined"
              style={{ width: "100%" }}
            >
              {timeRangeOptions.map((val) => {
                return (
                  <MenuItem value={val.value} key={val.value}>
                    {t(`labels.dashboard.filters.${val.label}`)}
                  </MenuItem>
                );
              })}
            </TextField>
          </Grid>

          <Grid item xs={4}>
            <DateField
              label={t("labels.dashboard.filters.dateRangeFrom")}
              isRequired={true}
              labelErrorText={""}
              initialValue={fromDate}
              disabled={timeRange !== -1}
              onChange={onFromDateChange}
            />
          </Grid>
          <Grid item xs={4}>
            <DateField
              label={t("labels.dashboard.filters.dateRangeTo")}
              isRequired={true}
              labelErrorText={""}
              initialValue={toDate}
              disabled={timeRange !== -1}
              onChange={onToDateChange}
            />
          </Grid>
        </Grid>
        <Grid item container xs={12} spacing={2}>
          <Grid item xs={6}>
            <SearchableSelect
              label={t("labels.dashboard.filters.country")}
              options={countryList}
              value={country}
              changeHandler={onCountryChange}
            />
          </Grid>
        </Grid>
      </Grid>
    </ModalDialog>
  );
};

export default FilterForm;
